import { styled as r } from "./styled2.mjs";
import { Button as o } from "./index26.mjs";
import { buttonClasses as i, typographyClasses as a } from "@mui/material";
const c = r(o)`
	min-width: 0px;
	width: 100%;
	transition: ${({ theme: n, $isExpanded: t }) => n.transitions.create(["left", "right"], {
  easing: n.transitions.easing.sharp,
  duration: t ? n.transitions.duration.enteringScreen : n.transitions.duration.leavingScreen
})};

	& .${i.startIcon} {
		margin: 0;
	}

	&.${i.root} > .${a.root} {
		opacity: ${({ $isExpanded: n }) => n ? 1 : 0};
		margin-left: ${({ theme: n, $isExpanded: t }) => t ? n.tokens.spacing[8] : 0};
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: block;
		white-space: nowrap;
		transition: ${({ theme: n, $isExpanded: t }) => n.transitions.create("opacity", {
  easing: n.transitions.easing.sharp,
  duration: t ? n.transitions.duration.enteringScreen : n.transitions.duration.leavingScreen
})};
	}
`;
export {
  c as FabButton
};
//# sourceMappingURL=styles94.mjs.map
